import Head from 'next/head';
import dynamic from 'next/dynamic';

import { heights } from '#app/helpers/scroll-to';
import Layout from '#layout/index';
import { useUserGeolocalization } from '#hooks/index';
import { WhatsAppLogo } from '#layout/helpers';
import { postPathsAndCourses } from '#api/rutas-y-cursos/rutas-y-cursos';

// Dynamic Components
const Hero = dynamic(() => import('../../app/UI/organisms/hero'));
const Promotion = dynamic(() => import('../../app/pages/vacaciones-tech/promotion'));
const Catalog = dynamic(() => import('../../app/pages/vacaciones-tech/catalog'));
const FAQs = dynamic(() => import('../../app/UI/organisms/faqs'));
const Advice = dynamic(() => import('../../app/UI/organisms/advice'));
const Contact = dynamic(() => import('../../app/templates/contact'));
const FormContact = dynamic(() => import('../../app/pages/vacaciones-tech/form-contact'));

const VacationPage = ({ data }) => {
  const { data: geolocalizationData } = useUserGeolocalization();

  return (
    <>
      <Head>
        <title>Vacaciones Tech | Crack The Code</title>
        <meta name="description" content="Vacaciones Tech" />
      </Head>
      <Layout mainType="full_variant">
        <Hero
          title="Vacaciones Tech"
          description="¡Que el tiempo libre de tu hij@ sirva para potenciar su futuro con nuevas habilidades digitales!"
          image={[
            './vacaciones-tech/hero-desktop.webp',
            './vacaciones-tech/hero-mobile.webp'
          ]}
          button={{
            name: '¡Ver los cursos!',
            type: 'scroll',
            scrollOptions: {
              to: 'catalog',
              offset: {
                mobile: {
                  hidden: -heights.mobile.header,
                  visible: -heights.mobile.header
                },
                desktop: {
                  hidden: -heights.desktop.header,
                  visible: -heights.desktop.header
                }
              }
            },
            href: '/cursos',
            variant: 'white',
            height: '56px',
            fontSize: [21, 16],
            lineHeight: [21, 21],
            fontWeight: 700
          }}
          paddingTop={[80, 60]}
          paddingBottom={[64, 350]}
          titleColor="white"
          descriptionColor="white"
          backgroundColor="#1a1040"
          bottomPX={[0, 0]}
          rightPX={[0, 0]}
        />
        <Promotion
          title="Tenemos el programa ideal para tus hijos"
          start="Inicios Febrero 2023"
          end="Cierre de inscripciones 31 de Enero. Cupos limitados"
          images={{
            CO: [
              './vacaciones-tech/promotion/CO/promotion-desktop.webp',
              './vacaciones-tech/promotion/CO/promotion-mobile.webp'
            ],
            MX: [
              './vacaciones-tech/promotion/MX/promotion-desktop.webp',
              './vacaciones-tech/promotion/MX/promotion-mobile.webp'
            ],
            PE: [
              './vacaciones-tech/promotion/PE/promotion-desktop.webp',
              './vacaciones-tech/promotion/PE/promotion-mobile.webp'
            ],
            US: [
              './vacaciones-tech/promotion/US/promotion-desktop.webp',
              './vacaciones-tech/promotion/US/promotion-mobile.webp'
            ]
          }}
          geolocalizationData={geolocalizationData}
        />
        {data && (
          <Catalog
            ages={data.data_ages}
            doubles={data['Súper Promociones']}
            simples={data['Cursos Individuales']}
          />
        )}
        <FAQs />
        <Advice
          title="¿Te ayudamos a elegir un curso para tus hijos?"
          description="Nuestro equipo de asesores educativos se encuentra enteramente disponible para ayudarte a encontrar el curso o ruta de programación más conveniente para tu hij@"
          padding={{
            top: [42, 32],
            right: [32, 32],
            bottom: [42, 32],
            left: [32, 32]
          }}
          margin={{ right: [0, 20], bottom: [120, 80], left: [0, 20] }}
        />
        <Contact
          title="¡Da el primer paso e impulsa su futuro!"
          description="Regístrate para contactarnos y ayudarte a conocer el mejor curso tech de acuerdo a la edad y los intereses de tu coder."
          paddingTop={[109, 64]}
          paddingBottom={[109, 100]}
          text={{ width: ['100%', '100%'] }}
          form={{ width: [668, '100%'] }}
        >
          <FormContact />
        </Contact>

        <WhatsAppLogo fixLanding />
      </Layout>
    </>
  );
};

VacationPage.getInitialProps = async () => {
  const response = await postPathsAndCourses({ page: 'tech_vacation' });

  if (response?.detail === 'Not found.') {
    return { data: response, notFound: true };
  }
  return { data: response, notFound: false };
};
export default VacationPage;
